$(document).ready(function () {
    // $(".main_nav li a, .scrollBtn, a.info-anchor").on("click", function (a) {
    $(".scrollBtn, a.info-anchor").on("click", function (a) {
        a.preventDefault();
        var e = $(this).attr("href"),
            i = $(e).offset().top;
        $("body,html").animate({scrollTop: i}, 500), $(".xs_menu").removeClass("active");
    });

    $(function () {
        $(".show_places_map").click(function () {
            get2GISMap($(this).data('2gis-map'), 'places_map_cont', $(this).data('default-city-smapc'), $(this).data('city-name'))
            $(".places").toggleClass("places_map");
        });
    });

    $(function () {
        $(".main_slider").owlCarousel({
            items: 1,
            loop: !0,
            autoplay: !0,
            dots: !1,
            nav: !1,
            autoplayTimeout: 5e3,
            autoplayHoverPause: !1,
            lazyLoad: !0
        });
    });

    $(function () {
        // Модальное окно отображается только при отсутствии
        // cookie selectedCity
        if (!getCookie('selectedCity')) {
            $("#region_modal").modal("show");
        }
    });

    $(function () {
        ((/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && $(document).width() < 991) || $(document).width() < 991) &&
        ($(".reviews_cont").addClass("owl-carousel"),
            $(".reviews_cont").owlCarousel({
                items: 2,
                loop: !0,
                autoplay: !0,
                autoplayTimeout: 1e4,
                autoplayHoverPause: !1,
                margin: 20,
                dots: !0,
                lazyLoad: !0,
                responsive: {
                    0: {items: 1, margin: 0},
                    768: {items: 1, stagePadding: 160},
                    992: {items: 2, stagePadding: 60},
                    1300: {items: 3, stagePadding: 67},
                    1600: {items: 4, stagePadding: 100},
                    1800: {items: 6, stagePadding: 100},
                },
            })),
            $(".advertising_slide").owlCarousel({
                items: 2,
                dots: !1,
                nav: !1,
                loop: !0,
                autoplay: !0,
                lazyLoad: !0,
                autoplayTimeout: 5e3,
                margin: 20,
                autoplayHoverPause: !1,
                autoWidth: !0,
                center: !0,
                stagePadding: 20,
                responsive: {
                    0: {items: 1, stagePadding: 40},
                    500: {items: 2, stagePadding: 40},
                    768: {items: 3, stagePadding: 40},
                    991: {items: 4, stagePadding: 30},
                    1300: {items: 4},
                    1600: {items: 6, center: !0}
                },
            });

        /*$(".advantage_big").owlCarousel({
            items: 2,
            loop: !0,
            autoplay: !1,
            autoplayTimeout: 5e3,
            margin: 10,
            autoplayHoverPause: !1,
            navElement: 'p',
            responsive: {0: {items: 1}, 575: {}, 991: {}, 1300: {}, 1600: {}}
        });*/

        $(".advantage_big").slick({
            slidesToShow: 2,
            // adaptiveHeight: true,
            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 5000,
            mobileFirst: true,
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        // rows: 2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
            ]
        });

        $(".img_slide").owlCarousel({
            items: 1,
            loop: !0,
            autoplay: !0,
            dots: !0,
            autoplayTimeout: 5e3,
            autoplayHoverPause: !1,
            lazyLoad: !0
        });

        $(".reviews_slider").owlCarousel({
            items: 2,
            loop: !0,
            autoplay: false,
            autoplayTimeout: 5e3,
            autoplayHoverPause: !1,
            margin: 20,
            dots: !0,
            autoWidth: true,
            lazyLoad: !0,
            responsive: {
                0: {
                    items: 1,
                    margin: 0,
                    autoWidth: false
                },
                768: {items: 2, stagePadding: 160},
                992: {items: 2, stagePadding: 60},
                1300: {items: 3, stagePadding: 67},
                1600: {items: 4, stagePadding: 100},
                1800: {items: 6, stagePadding: 100},
            },
        }),
            $(".top_photos_slider").owlCarousel({
                items: 3,
                loop: !0,
                autoplay: !1,
                autoplayTimeout: 5e3,
                autoplayHoverPause: !1,
                dots: false,
                autoWidth: !0,
                lazyLoad: !0,
                responsive: {
                    0: {items: 1, center: !1},
                    768: {items: 1},
                    992: {},
                    1300: {},
                    1600: {items: 4},
                    1800: {items: 5}
                },
            }),
            $(".instagram_photos_slider").owlCarousel({
                items: 6,
                loop: !0,
                autoplay: !1,
                autoplayTimeout: 5e3,
                autoplayHoverPause: !1,
                autoWidth: !1,
                margin: 20,
                nav: !0,
                lazyLoad: !0,
                responsive: {
                    0: {items: 1},
                    400: {items: 2},
                    650: {items: 3},
                    768: {items: 4},
                    992: {},
                    1300: {items: 6},
                    1600: {},
                    1800: {}
                },
            }),
            $(".vk_photos_slider").owlCarousel({
                items: 5,
                loop: !0,
                autoplay: !1,
                autoplayTimeout: 5e3,
                autoplayHoverPause: !1,
                nav: !0,
                lazyLoad: !0,
                responsive: {0: {}, 768: {}, 992: {}, 1300: {}, 1600: {}, 1800: {}}
            });
    }),
        $(function () {
            $(".institution_gallery").owlCarousel({
                items: 1,
                loop: !0,
                autoplay: !0,
                dots: !0,
                nav: !0,
                autoplayTimeout: 5e3,
                autoplayHoverPause: !1,
                lazyLoad: !0
            });
        }),
        $(function () {
            $(".carousel-control-next").click(function () {
                var a = $(".carousel-indicators").scrollLeft() + 100;
                $(".carousel-indicators").scrollLeft(a);
            }),
                $(".carousel-control-prev").click(function () {
                    var a = $(".carousel-indicators").scrollLeft() - 120;
                    $(".carousel-indicators").scrollLeft(a);
                }),
                $(".carousel-indicators li").click(function () {
                    var a = $(this).offset().left;
                    $(".carousel-indicators").scrollLeft(a);
                });
        }),
        $(function () {
            $(".custom_select_btn").click(function () {
                $(this).hasClass("active") || $(".custom_select_btn").removeClass("active"), $(this).toggleClass("active");
            }),
                $(document).on("click", function (a) {
                    $(a.target).closest(".custom_select").length || $(".custom_select_btn").removeClass("active"), a.stopPropagation();
                }),
                $('.places_cont').on('click', '.show_phone', function () {
                    // $(this).parent().parent().hasClass("active") || $(".card").removeClass("active"), $(this).parent().parent().toggleClass("active");
                    if ($(this).closest('.card').hasClass('active') || $(".card").removeClass("active")) {
                        $(this).closest('.card').toggleClass('active');
                    }
                });
            $(".fast_filter").click(function () {
                $(".filter").slideToggle();
                this.scrollIntoView({
                    behavior: 'smooth'
                });
            }),
                $(".read_more_info").click(function () {
                    $(this).css("display", "none"), $(".hide_more_info").css("display", "block"), $(".read_more_cont_mob").slideToggle(), $(".contacts_more_inf").css("display", "flex"), $(".info_blocks").css("display", "flex");
                }),
                $(".hide_more_info").click(function () {
                    $(this).css("display", "none"), $(".read_more_info").css("display", "block"), $(".read_more_cont_mob").slideToggle();
                }),
                // $(".add_sauna_btn").click(function () {
                //     $(".add_sauna_form").slideToggle();
                // }),
                $(".complain_btn").click(function () {
                    $(".modal").modal("hide"), $("#leave_complaint_modal").modal("show");
                }),
                $(".city_list li a").click(function () {
                    $("#modal_city").modal("hide"), $(".city_list li a").removeClass("active");
                    var a = $(this).text();
                    $(".choose_city").text(a), $(this).addClass("active");
                });
        }),
        $(function () {
            $(".active_map_yandex").click(function () {
                $(".btn_map_active, .map_link").removeClass("active"), $(this).addClass("active"), $(".map_yandex").addClass("active");
            }),
                $(".active_map_google").click(function () {
                    $(".btn_map_active, .map_link").removeClass("active"), $(this).addClass("active"), $(".map_google").addClass("active");
                }),
                $(".active_map_2gis").click(function () {
                    $(".btn_map_active, .map_link").removeClass("active"), $(this).addClass("active"), $(".map_2gis").addClass("active");
                });
        }),

        /*$(function () {
            $("input[name=add_payment]").on("click", function () {
                $(this).is(":checked") && $("#add_payment_val").html($(this).val());
            }),
                $("input[name=add_price]").on("change", function () {
                    var a = $(this).val();
                    1 < a ? ($(this).removeClass("error"), $("#add_price_val").html(a)) : $(this).addClass("error");
                }),
                $("input[name=for_period]").on("click", function () {
                    var a = $(this).val();
                    $(this).is(":checked") && $("#for_period_val").html(a);
                }),
                $("input[name=max_capacity]").on("change", function () {
                    var a = $(this).val();
                    1 < a ? ($(this).removeClass("error"), $("#max_capacity_val").html(a)) : $(this).addClass("error");
                });
        }),*/

        $(function () {
            $(".add_room_btn").click(function () {
                !(function () {
                    var a = $(".room").length,
                        e = 0;
                    e = 0 == a ? 1 : parseInt($(".rooms").find("div.room:last").attr("id").slice(4)) + 1;
                    $("div.rooms").append(
                        '<div id="room' +
                        e +
                        '" class="room"><div class="top_line"><h6 class="h6">Номер ' +
                        e +
                        '</h6><div class="delete_room" id="delete_room' +
                        e +
                        '" onclick="javascript: this.closest(\'.room\').remove()"> <img src="images/svg/close.svg" alt="close"> Удалить номер</div></div><div class="row"><div class="inp col-lg-4"><input type="text" name="roomName' +
                        e +
                        '" id="roomName' +
                        e +
                        '" placeholder="Название номера/зала"><span>Пример – Зеленый, Охотничий, Царский, Зал 1, Домик 1</span></div><div class="inp col-lg-4"><input type="text" name="roomCapacity' +
                        e +
                        '" id="roomCapacity' +
                        e +
                        '" placeholder="Вместимость, до "><span>Вместимость номера/зала (максимальное количество гостей, включая людей с доплатой)*</span></div><div class="inp col-lg-4"><div class="custom_select"><button type="button" name="roomSteamType' +
                        e +
                        '" id="roomSteamType' +
                        e +
                        '" class="custom_select_btn">Тип парной</button><ul class="select_list"><li><label><input type="checkbox"><span>Русская</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="checkbox"><span>Русская на дровах</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="checkbox"><span>С веником</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="checkbox"><span>Римская</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="checkbox"><span>Турецкая</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="checkbox"><span>Финская</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="checkbox"><span>Инфокрасная</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="checkbox"><span>Японская</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="checkbox"><span>Финская</span><i class="fas fa-check fas_icon"></i></label></li></ul></div></div><div class="inp col-lg-4"><input type="text" name="roomMinPrice' +
                        e +
                        '" id="roomMinPrice' +
                        e +
                        '" placeholder="Минимальная цена"><span>Минимальная цена (как правило в будни или по акции)*</span></div><div class="inp col-lg-4"><input type="text" name="roomMaxPrice' +
                        e +
                        '" id="roomMaxPrice' +
                        e +
                        '" placeholder="Максимальная цена"><span>Максимальная цена (как правило в праздники и выходные)*</span></div><div class="inp col-lg-4"><div class="custom_select"><button type="button" name="min_order' +
                        e +
                        '" id="min_order' +
                        e +
                        '" class="custom_select_btn">Минимальный заказ</button><ul class="select_list"><li><label><input type="radio" name="min_order"><span>2ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>3ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>4ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>5ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>6ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>7ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>8ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>9ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>10ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>11ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>12ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>13ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>14ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>15ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>16ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>17ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>18ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>19ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>20ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>21ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>22ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>23ч</span><i class="fas fa-check fas_icon"></i></label></li><li><label><input type="radio" name="min_order"><span>24ч</span><i class="fas fa-check fas_icon"></i></label></li></ul></div></div><div class="inp col-lg-12"><input type="text" placeholder="Перечень услуг (кратко)"><span>Услуги (пример: бассейн, можно париться с веником, джакузи, купель, зона отдыха со столом для гостей2 комнаты отдыха, обливное ведро, ТВ, караоке, банные принадлежности, настольные игры, бар, банкетный зал)*</span></div><div class="inp col-lg-12"><textarea name="roomDesc' +
                        e +
                        '" id="roomDesc' +
                        e +
                        '" placeholder="Описание номера"></textarea><span>Описание номера /зала /сауны (Укажите: весь перечень услуг, чтобы у посетителей было меньше вопросов к администраторам заведения. Обязательно укажите сумму доплаты за дополнительного человека если количество посетителей превышает номинал. Минимальный заказ. Разместите прайс по дням и часам.)*</span></div></div></div>'
                    );
                })(),
                    $(".custom_select_btn").click(function () {
                        $(this).hasClass("active") || $(".custom_select_btn").removeClass("active"), $(this).toggleClass("active");
                    });
            }),
                $(".add_room_photos_btn").click(function () {
                    !(function () {
                        var a = $(".room_photo").length,
                            e = 0;
                        e = 0 == a ? 1 : parseInt($(".room_photos").find("div.room_photo:last").attr("id").slice(10)) + 1;
                        $("div.room_photos").append(
                            '<div id="room_photo' +
                            e +
                            '" class="room_photo"><div class="top_line"><h6 class="h6">Фото ' +
                            e +
                            '</h6><div class="delete_roomPhoto" id="delete_roomPhoto' +
                            e +
                            '" onclick="javascript: this.closest(\'.room_photo\').remove()"> <img src="images/svg/close.svg" alt="close"> Удалить фото</div></div><div class="row"><div class="inp col-md-12 col-lg-6"><div class="custom-file"><label class="btn_bl"><input type="file" name="roomPhoto' +
                            e +
                            '" id="roomPhoto' +
                            e +
                            '"><div class="btn_m">Выберите фото</div></label><input type="text" class="inp_output" name="inp_outputRoomPhoto' +
                            e +
                            '"></div></div><div class="inp col-md-12 col-lg-6"><div class="custom-file"><input type="text" class="inp_output" name="altRoomPhoto' +
                            e +
                            '" placeholder="Подпись для фото ' +
                            e +
                            '"></div></div></div></div>'
                        );
                    })();
                });
        }),
        $(function () {
            $(window).scroll(function () {
                100 < $(this).scrollTop() ? $(".scrollup").addClass("active") : $(".scrollup").removeClass("active");
            }),
                $(".scrollup").click(function () {
                    return $("html, body").animate({scrollTop: 0}, 600), !1;
                });
        }),

        $(function () {
            $(".o_xs_menu").click(function () {
                $(".xs_menu").addClass("active").addClass("overflow-y-visible");
                $("body").css('overflow-y', 'hidden');
            });
            $(".c_xs_menu").click(function () {
                $(".xs_menu").removeClass("active").removeClass("overflow-y-visible");
                $("body").css('overflow-y', '');
            });
        });

        $(function () {
            $(".close").click(function () {
                $(".modal_m").css("display", "none");
            }),
                $(".close_modal").click(function () {
                });
        });


    /**
     * @todo Продумать логику нажатия на миниатюру и отображение большого фото
     * e - большое фото
     * i - миниатюры
     */
    $(function () {
        var e = $("#sync1"), i = $("#sync2");

        e.on("click", ".owl-next", function () {
            i.trigger("next.owl.carousel");
        });

        e.on("click", ".owl-prev", function () {
            i.trigger("prev.owl.carousel");
        });

        e.owlCarousel({
            loop: !0,
            items: 1,
            margin: 0,
            smartSpeed: 700,
            lazyLoad: !0,
            autoplay: true,
            autoplayTimeout: 5e3,
            autoplayHoverPause: !0,
            dots: false,
            nav: !0,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        }).on("dragged.owl.carousel", function (a) {
            ("left" === a.relatedTarget.state.direction) ? i.trigger("next.owl.carousel") : i.trigger("prev.owl.carousel");
        });

        i.owlCarousel({
            loop: !0,
            items: 5,
            autoplay: true,
            autoplayTimeout: 5e3,
            autoplayHoverPause: !0,
            smartSpeed: 700,
            margin: 16,
            dots: false,
            responsive: {0: {items: 3}, 768: {}}
        }).on("click", ".owl-item", function () {
            var a = $(this).index() - 6;

            i.trigger("to.owl.carousel", [a, 300, !0]);
            e.trigger("to.owl.carousel", [a, 300, !0]);
        });
    });

    /**
     * При вызове модального окна place активируем скрипты модуля slick
     */
    $('a[data-target="#place_modal"]').on('click', function () {
        $('.place-slider .slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            dots: false,
            lazyLoad: 'progressive',
            // adaptiveHeight: true,
            asNavFor: '.slider-nav',
            responsive: [
                {
                    breakpoint: 420,
                    settings: {
                        arrows: false,
                        dots: false,
                    }
                }
            ]
        });

        $('.place-slider .slider-nav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            arrows: false,
            dots: false,
            focusOnSelect: true,
            swipeToSlide: true,
            adaptiveHeight: true,
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 420,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

//     $(function () {
//         particlesJS("particles-js", {
//             particles: {
//                 number: {value: 160, density: {enable: !0, value_area: 800}},
//                 color: {value: "#ffffff"},
//                 shape: {
//                     type: "circle",
//                     stroke: {width: 0, color: "#000000"},
//                     polygon: {nb_sides: 5},
//                     image: {src: "img/github.svg", width: 100, height: 100}
//                 },
//                 opacity: {value: 1, random: !0, anim: {enable: !0, speed: 1, opacity_min: 0, sync: !1}},
//                 size: {value: 3, random: !0, anim: {enable: !1, speed: 4, size_min: 0.3, sync: !1}},
//                 line_linked: {enable: !1, distance: 150, color: "#ffffff", opacity: 0.4, width: 1},
//                 move: {
//                     enable: !0,
//                     speed: 1,
//                     direction: "none",
//                     random: !0,
//                     straight: !1,
//                     out_mode: "out",
//                     bounce: !1,
//                     attract: {enable: !1, rotateX: 600, rotateY: 600}
//                 },
//             },
//             interactivity: {
//                 detect_on: "canvas",
//                 events: {onhover: {enable: !0, mode: "bubble"}, onclick: {enable: !0, mode: "repulse"}, resize: !0},
//                 modes: {
//                     grab: {distance: 400, line_linked: {opacity: 1}},
//                     bubble: {distance: 250, size: 0, duration: 2, opacity: 0, speed: 3},
//                     repulse: {distance: 400, duration: 0.4},
//                     push: {particles_nb: 4},
//                     remove: {particles_nb: 2},
//                 },
//             },
//             retina_detect: !0,
//         });
//     });
// }),
//     $(function () {
//         $("input[type=number]").change(function () {
//             $(this).val() < 0 && $(this).val(1);
//         });
});
